import { call, put, takeLatest, takeEvery } from "redux-saga/effects";
import { actions } from "./slice";
import * as API from "../../../../../services/apis";

export function* handleFetchOrders({ payload }) {
  try {
    const res = yield call(API.fetchAllOrders, payload);
    const { data } = res;
    yield put(actions.fetchOrdersSuccess(data));
  } catch (err) {
    yield put(actions.fetchOrdersFailure(err?.response?.data));
  }
}

export function* handleFetchPendingOrderReport({ payload }) {
  try {
    const res = yield call(API.fetchPaymentReport, payload);
    const { data } = res;
    yield put(actions.fetchPendingOrderReportSuccess(data));
  } catch (err) {
    yield put(actions.fetchPendingOrderReportFailure(err?.response?.data));
  }
}

export function* handleFetchDropdown({ payload }) {
  try {
    const res = yield call(API.fetchDropdown, payload);
    const { data } = res;
    yield put(actions.fetchDropdownSuccess(data));
  } catch (err) {
    yield put(actions.fetchDropdownFailure(err?.response?.data));
  }
}

export function* handleFetchCommodities({ payload }) {
  try {
    const res = yield call(API.fetchAllCommodities, payload);
    const { data } = res;
    yield put(actions.fetchCommoditiesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCommoditiesFailure(err?.response?.data));
  }
}

export function* handleFetchStates({ payload }) {
  try {
    const res = yield call(API.fetchAllStates, payload);
    const { data } = res;
    yield put(actions.fetchStatesSuccess(data));
  } catch (err) {
    yield put(actions.fetchStatesFailure(err?.response?.data));
  }
}

export function* handleFetchDistricts({ payload }) {
  try {
    const res = yield call(API.fetchDistrictsForState, payload);
    const { data } = res;
    yield put(actions.fetchDistrictsSuccess(data));
  } catch (err) {
    yield put(actions.fetchDistrictsFailure(err?.response?.data));
  }
}

export function* handleFetchSamplers({ payload }) {
  try {
    const res = yield call(API.fetchSamplersForDistrict, payload);
    const { data } = res;
    yield put(actions.fetchSamplersSuccess(data));
  } catch (err) {
    yield put(actions.fetchSamplersFailure(err?.response?.data));
  }
}

export function* handleFetchProjectCodes({ payload }) {
  try {
    const res = yield call(API.fetchAllProjectCodes, payload);
    const { data } = res;
    yield put(actions.fetchProjectCodesSuccess({data, for: payload.for }));
  } catch (err) {
    yield put(actions.fetchProjectCodesFailure(err?.response?.data));
  }
}

export function* handleFetchLabs({ payload }) {
  try {
    const res = yield call(API.fetchAllLabs, payload);
    const { data } = res;
    yield put(actions.fetchLabsSuccess(data));
  } catch (err) {
    yield put(actions.fetchLabsFailure(err?.response?.data));
  }
}

export function* handleFetchLogisticPartners({ payload }) {
  try {
    const res = yield call(API.fetchAllLogisticPartners, payload);
    const { data } = res;
    yield put(actions.fetchLogisticPartnersSuccess(data));
  } catch (err) {
    yield put(actions.fetchLogisticPartnersFailure(err?.response?.data));
  }
}

export function* handleUpdateLab({ payload }) {
  try {
    const res = yield call(API.updateOrder, payload);
    const { data } = res;
    // yield put(actions.fetchOrders({ query: `page=1&limit=10` }));
    yield put(actions.updateLabSuccess(data));
    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (err) {
    yield put(actions.updateLabFailure({ id: payload.id, err }));
    payload.onFailure();
  }
}

export function* handleUpdateSampler({ payload }) {
  try {
    const res = yield call(API.assignSampler, payload);
    const { data } = res;
    yield put(actions.updateSamplerSuccess(data));
    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (err) {
    console.log("error occured");
    if (err?.response?.status === 500)
      yield put(
        actions.updateSamplerFailure({
          message: "Something has gone wrong on the web site's server.",
        })
      );
    else yield put(actions.updateSamplerFailure(err?.response?.data));
    payload.onFailure();
  }
}

export function* handleAddOrder({ payload }) {
  try {
    const res = yield call(API.addOrder, payload);
    const { data } = res;
    yield put(actions.fetchOrders({ query: `page=1&limit=10` }));
    yield put(actions.addOrderSuccess(data));
    if (payload.onSuccess) {
      payload.onSuccess(data.data);
    }
  } catch (err) {
    yield put(actions.addOrderFailure({ id: payload.id, err }));
    console.log({err});
    payload.onFailure(err?.response?.data);
  }
}

export function* handleUpdateLogistics({ payload }) {
  try {
    const res = yield call(API.updateOrder, payload);
    const { data } = res;
    yield put(actions.updateLogisticsSuccess(data));
    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (err) {
    yield put(actions.updateLogisticsFailure(err?.response?.data));
    payload.onFailure();
  }
}

export function* handleUpdateOrderStatus({ payload }) {
  try {
    const res = yield call(API.updateOrder, payload);
    const { data } = res;
    yield put(actions.updateOrderStatusSuccess(data));
    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (err) {
    if (err?.response?.status === 500)
      yield put(
        actions.updateOrderStatusFailure({
          message: "Something has gone wrong on the web site's server.",
        })
      );
    else yield put(actions.updateOrderStatusFailure(err?.response?.data));
    payload.onFailure();
  }
}

export function* handleUpdateOrder({ payload }) {
  try {
    const res = yield call(API.updateOrder, payload);
    const { data } = res;
    yield put(actions.updateOrderSuccess(data));
    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (err) {
    if (err?.response?.status === 500)
      yield put(
        actions.updateOrderFailure({
          message: "Something has gone wrong on the web site's server.",
        })
      );
    else yield put(actions.updateOrderFailure(err?.response?.data));
    payload.onFailure();
  }
}

export function* handleServiceRequest(payload) {
  try {
    const res = yield call(API.contactSupport, {
      data: payload.payloadData.data,
    });
    const { data } = res;
    yield put(actions.serviceRequestSuccess(data));

    //if (payload.payloadData.onSuccess) payload.payloadData.onSuccess();
  } catch (err) {
    if (err?.response?.status === 500)
      yield put(
        actions.serviceRequestFailure({
          message: "Something has gone wrong on the web site's server.",
        })
      );
    else yield put(actions.serviceRequestFailure(err?.response?.data));
    //if (payload.payloadData.onFailure) payload.payloadData.onFailure();
  }
}

export function* handleUploadReport({ payload }) {
  try {
    // upload file
    console.log("Report UPLOAD SAGA");
    const res = yield call(API.getFileUrl, {
      //fileName: payload.file.name,
      //source: payload.source,
      //fileUsedFor: payload.fileUsedFor,
      //companyId: payload.companyId,
      //orderId: payload.orderId,
      blobName: payload.file.name,
      source: {
        name: process.env.REACT_APP_ENVIRONMENT,
      },
    });
    const url = res.data?.data?.document;
    const formData = new FormData();
    formData.append("file", payload.file);
    const fileUploadRes = yield call(API.uploadFile, { data: formData, url });
    if (fileUploadRes.status > 400) {
      throw new Error("Error uploading file");
    }
    // update order
    //const fileUploadedUrl = new URL(url);
    //const pathName = fileUploadedUrl?.pathname.slice(1);
    const updatePayload = {
      data: {
        //reportFile: pathName,
        reportFile: payload.file.name,
        // status: payload.status,
      },
      id: payload.id,
    };
    if (payload.status) {
      updatePayload.data.status = payload.status;
    }
    const updateRes = yield call(API.updateOrder, updatePayload);
    yield put(actions.uploadReportSuccess(updateRes.data));
    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (err) {
    yield put(actions.uploadReportFailure({ id: payload.id, err }));
    payload.onFailure();
  }
}

export function* handleUploadPurchaseOrder({ payload }) {
  try {
    // upload file
    const res = yield call(API.getFileUrl, {
      //fileName: payload.file.name,
      //source: payload.source,
      //companyId: payload.companyId,
      blobName: payload.file.name,
      source: {
        name: process.env.REACT_APP_ENVIRONMENT,
      },
    });
    const url = res.data?.data?.document;
    const formData = new FormData();
    formData.append("file", payload.file);
    const fileUploadRes = yield call(API.uploadFile, { data: formData, url });
    if (fileUploadRes.status > 400) {
      throw new Error("Error uploading file");
    }
    // update order
    //const fileUploadedUrl = new URL(url);
    //const pathName = fileUploadedUrl?.pathname.slice(1);
    const updatePayload = {
      data: {
        purchaseOrderFile: payload.file.name,
        purchaseOrderNumber: payload.purchaseOrderNumber,
      },
      id: payload.id,
    };
    const updateRes = yield call(API.updateOrder, updatePayload);
    yield put(actions.uploadPurchaseOrderSuccess(updateRes.data));
    if (payload.onSuccess) {
      payload.onSuccess();
    }
  } catch (err) {
    console.log(err);
    yield put(actions.uploadPurchaseOrderFailure({ id: payload.id, err }));
    payload.onFailure();
  }
}

export function* handlePurchaseOrderDownload({ payload }) {
  try {
    const { fileName } = payload.data;
    //const res = yield call(API.getDownloadUrl, payload);
    const res = yield call(API.getFileUrl, {
      blobName: fileName,
      source: {
        name: process.env.REACT_APP_ENVIRONMENT,
      },
    });
    const { data } = res;
    const file = yield call(API.downloadFile, {
      url: data.data.document,
      data: "",
    });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(file.data);
    link.setAttribute(
      "download",
      fileName.split("_")[fileName.split("_").length - 1]
    );
    link.setAttribute("target", "_blank");
    document.body.appendChild(link);
    link.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
    document.body.removeChild(link);
    yield put(actions.downloadPurchaseOrderSuccess({ id: payload.id }));
  } catch (err) {
    yield put(actions.downloadPurchaseOrderFailure({ id: payload.id, err }));
  }
}

export function* handleFetchCompanies({ payload }) {
  try {
    const res = yield call(API.fetchAllCompanies, payload);
    const { data } = res;
    yield put(actions.fetchCompaniesSuccess(data));
  } catch (err) {
    yield put(actions.fetchCompaniesFailure(err?.response?.data));
  }
}
export function* handleFetchCompanyUsers({ payload }) {
  try {
    const res = yield call(API.fetchCompanyUsers, payload);
    const { data } = res;
    yield put(actions.fetchCompanyUsersSuccess(data));
  } catch (err) {
    yield put(actions.fetchCompanyUsersFailure(err?.response?.data));
  }
}

export function* handleBulkLabAssignment({ payload }) {
  try {
    const res = yield call(API.updateOrder, payload);
    const { data } = res;
    yield put(actions.bulkLabAssignmentSuccess());
    payload.onSuccess(data?.document);
  } catch (err) {
    yield put(actions.bulkLabAssignmentFailure());
    payload.onFailure();
    console.error(err);
  }
}

export function* handleBulkChangeOrderStatus({ payload }) {
  try {
    const res = yield call(API.updateOrderStatus, payload.data);
    const { data } = res;
    yield put(actions.bulkChangeOrderStatusSuccess());
    payload.onSuccess(data?.document);
  } catch (err) {
    yield put(actions.bulkChangeOrderStatusFailure());
    payload.onFailure(err?.response?.data?.document);
  }
}

export function* handleLogisticsAssignment({ payload }) {
  try {
    const res = yield call(
      API.assignLogisticAndTrackingIdToOrder,
      payload.data
    );
    const { data } = res;
    yield put(actions.logisticsAssignmentSuccess());
    payload.onSuccess(data?.document);
  } catch (err) {
    yield put(actions.logisticsAssignmentFailure());
    payload.onFailure();
  }
}

export function* handleBulkSamplerAssignment({ payload }) {
  try {
    const res = yield call(API.assignSampler, payload);
    const { data } = res;
    yield put(actions.bulkSamplerAssignmentSuccess());
    payload.onSuccess(data?.document);
  } catch (err) {
    yield put(actions.bulkSamplerAssignmentFailure());
    payload.onFailure();
  }
}

export function* handleFetchSectors({ payload }) {
  try {
    const res = yield call(API.getSectors, payload);
    const { data } = res;
    yield put(actions.fetchSectorsSuccess(data));
  } catch (err) {
    yield put(actions.fetchSectorsFailure(err?.response?.data));
  }
}
export function* handleFetchPackages({ payload }) {
  try {
    const res = yield call(API.fetchPackagesByCompanyAndCommodity, payload);
    const { data } = res;
    yield put(actions.fetchPackagesSuccess(data));
  } catch (err) {
    yield put(actions.fetchPackagesFailure(err?.response?.data));
  }
}

export function* handleFetchProjectConfig({ payload }) {
  try {
    if (payload?.projectCodeId) {
      const res = yield call(API.fetchProjectConfig, payload);
      const { data } = res;
      yield put(actions.fetchProjectConfigSuccess(data));
    }
    payload.onSuccess();
  } catch (err) {
    yield put(actions.fetchProjectConfigFailure(err?.response?.data));
    payload.onFailure();
  }
}

export function* handleFetchAgencies({ payload }) {
  try {
    const res = yield call(API.fetchAgencies, payload);
    const { data } = res;
    yield put(actions.fetchAgenciesSuccess(data));
  } catch (err) {
    yield put(actions.fetchAgenciesFailure(err?.response?.data));
  }
}
/**
 * Root saga manages watcher lifecycle
 */
export function* orderListingSaga() {
  yield takeLatest(actions.fetchOrders.type, handleFetchOrders);
  yield takeLatest(actions.fetchDropdown.type, handleFetchDropdown);
  yield takeLatest(actions.fetchLabs.type, handleFetchLabs);
  yield takeLatest(actions.fetchCompanies.type, handleFetchCompanies);
  yield takeLatest(
    actions.fetchLogisticPartners.type,
    handleFetchLogisticPartners
  );
  yield takeEvery(actions.updateLab.type, handleUpdateLab);
  yield takeEvery(actions.updateSampler.type, handleUpdateSampler);
  yield takeEvery(actions.updateLogistics.type, handleUpdateLogistics);
  yield takeEvery(actions.updateOrderStatus.type, handleUpdateOrderStatus);
  yield takeEvery(
    actions.downloadPurchaseOrder.type,
    handlePurchaseOrderDownload
  );
  yield takeEvery(actions.uploadReport.type, handleUploadReport);
  yield takeEvery(actions.uploadPurchaseOrder.type, handleUploadPurchaseOrder);
  yield takeEvery(actions.updateOrder.type, handleUpdateOrder);
  yield takeLatest(
    actions.fetchPendingOrderReport.type,
    handleFetchPendingOrderReport
  );
  yield takeEvery(actions.serviceRequest.type, handleServiceRequest);
  yield takeLatest(actions.fetchCompanyUsers.type, handleFetchCompanyUsers);
  yield takeLatest(actions.fetchCommodities.type, handleFetchCommodities);
  yield takeLatest(actions.fetchStates.type, handleFetchStates);
  yield takeLatest(actions.fetchDistricts.type, handleFetchDistricts);
  yield takeLatest(actions.fetchSamplers.type, handleFetchSamplers);
  yield takeLatest(actions.fetchProjectCodes.type, handleFetchProjectCodes);
  yield takeEvery(actions.addOrder.type, handleAddOrder);
  yield takeEvery(actions.bulkLabAssignment.type, handleBulkLabAssignment);
  yield takeEvery(
    actions.bulkChangeOrderStatus.type,
    handleBulkChangeOrderStatus
  );
  yield takeEvery(actions.logisticsAssignment.type, handleLogisticsAssignment);
  yield takeEvery(
    actions.bulkSamplerAssignment.type,
    handleBulkSamplerAssignment
  );

  yield takeLatest(actions.fetchSectors.type, handleFetchSectors); 
  yield takeLatest(actions.fetchPackages.type, handleFetchPackages);
  yield takeLatest(actions.fetchProjectConfig.type, handleFetchProjectConfig);
  yield takeLatest(actions.fetchAgencies.type, handleFetchAgencies);

}
